import {Pipe, PipeTransform} from '@angular/core';

type StringPipeConfig = {
	truncate?: number;
	ellipsis?: string;
	toUpperCase?: boolean;
	toLowerCase?: boolean;
};

@Pipe({
	name: 'replace',
	standalone: true,
})
export class StringReplacePipe implements PipeTransform {
	transform(query: string, searchValue: string | RegExp, replaceValue: string): string {
		try {
			return query.replace(searchValue, replaceValue);
		} catch (e) {
			return query;
		}
	}
}
